import React, { useState } from 'react'
import axios from 'axios'
import { Modal, message, Button } from 'antd'
import MyInput from '../../../components/forms/input'

const AddChatbotFaq = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  const handleSubmit = () => {
    setErrorMsg({})
    if (!formValue.question) {
      setErrorMsg({questionEmpty: '问题不能为空'})
      return false
    }

    axios.post('/p/chatbot/faq/add', {
      merchant_oid: merchantOid,
      question: formValue.question
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('新常见问题创建成功！')
          props.getFaqList()
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleOk = () => {
    const isOk = handleSubmit()
    if (isOk !== false) {handleCancel()}
  }

  const handleNext = () => {
    handleSubmit()
    setFormValue({})
  }

  const handleCancel = () => {
    setErrorMsg({})
    setFormValue({})
    props.isCancel()
  }

  return (
    <>
      <Modal
        destroyOnClose={true}
        title="创建常见问题"
        width='800px'
        open={props.isOpen}
        onCancel={handleCancel}
        maskClosable={false}
        footer={[
          <Button key='cancel' onClick={handleCancel}>取消</Button>,
          <Button key='submit' onClick={handleNext}>提交并新建下一条</Button>,
          <Button key='isOk' type="primary" onClick={handleOk}>创建</Button>
        ]}>

        <MyInput
          id="question"
          required
          autoFocus
          maxLength={64}
          label='问题'
          placeholder='请输入文章的标题'
          value={formValue.question}
          onChange={setFormValue}
          errorMsg={errorMsg.questionEmpty}
        />
      </Modal>
    </>
  )
}

export default AddChatbotFaq
